export default {
    
    RESOURCES_URL: 'https://rcb.rosie.health/api/resources',

    SUBMIT_URL: 'https://rosie.kosova.health/api/submitEvaluation',
    
}